// extracted by mini-css-extract-plugin
export var activeFilterButton = "_rg-c";
export var backButton = "_rg-4";
export var backIcon = "_rg-5";
export var chevronShortcut = "_rg-6";
export var container = "_rg-1";
export var editor = "_rg-8";
export var editorWrapper = "_rg-7";
export var prefix = "_rg-2";
export var searchIcon = "_rg-3";
export var suffix = "_rg-9";
export var suffixContent = "_rg-a";
export var suffixText = "_rg-b";
export var wrapper = "_rg-0";